import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAsterisk: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="asterisk, placeholder"><path d="M11.999 2.75V21.25M3.98828 7.375L20.0098 16.625M3.98925 16.625L20.0107 7.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAsterisk;
